import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=4399c23b&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=4399c23b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4399c23b",
  null
  
)

export default component.exports